import { PUSH_CAMPAIGN_TYPE_OPTIONS, PushCampaignType } from '../constants/push-campaign.enum'

export const CAMPAIGN_STATUS = [
  { label: 'Gửi ngay', value: 'sent' },
  { label: 'Kế hoạch', value: 'scheduled' },
  { label: 'Đã hủy', value: 'cancelled' },
]

export const CAMPAIGN_TYPE = PUSH_CAMPAIGN_TYPE_OPTIONS

const normalize = (s: unknown) =>
  String(s ?? '')
    .trim()
    .toLowerCase()

export const getCampaignStatus = (status: string) => {
  switch (normalize(status)) {
    case 'sent':
      return [{ type: 'success', label: 'Gửi ngay' }]
    case 'scheduled':
      return [{ type: 'warn', label: 'Kế hoạch' }]
    case 'canceled':
      return [{ type: 'danger', label: 'Đã hủy' }]
    case 'running':
    case 'processing':
      return [{ type: 'info', label: 'Đang chạy' }]
    case 'pending':
      return [{ type: 'warn', label: 'Tạm dừng' }]
    case 'stopped':
      return [{ type: 'danger', label: 'Đã dừng' }]
    case 'completed':
    case 'done':
      return [{ type: 'success', label: 'Hoàn tất' }]
    default:
      return [{ type: 'info', label: status }]
  }
}

export const getCampaignType = (type: string) => {
  const t = normalize(type)
  switch (t) {
    case PushCampaignType.NotificationLink:
    case 'notification_link':
      // requirement: bg white + text black (default)
      return [
        {
          type: undefined,
          label: 'Thông báo + liên kết',
          class: 'campaign-type-link',
          style: { background: 'rgba(240, 240, 240, 1)', color: '#000000' },
        },
      ]
    case PushCampaignType.NotificationReward:
    case 'notification_reward':
      // requirement: bg rgba(255, 240, 228, 1) + text rgba(255, 111, 0, 1)
      return [
        {
          type: undefined,
          label: 'Thông báo + điểm thưởng',
          class: 'campaign-type-reward',
          style: { background: 'rgba(255, 240, 228, 1)', color: 'rgba(255, 111, 0, 1)' },
        },
      ]
    default:
      return [{ type: 'info', label: type }]
  }
}

type PushCampaignListItem = Record<string, unknown>

export const formatTableDataPushCampaign = (data: PushCampaignListItem[]) => {
  return data.map((item) => ({
    ...item,
    id: item['id'],
    campaign_type: getCampaignType(String(item['campaign_type'] ?? item['type'] ?? '')),
    status_text: getCampaignStatus(String(item['status'] ?? '')),
    name: String(item['title'] ?? item['name'] ?? ''),
    started_at: item['started_at'],
    ended_at: item['ended_at'],
    created_at: item['created_at'],
    created_by: (item['created_by'] as { full_name?: string } | undefined)?.full_name || '-',
    sent_count: item['sent_count']
      ? `${String(item['sent_count'])}/${String(item['total_count'] ?? '')}`
      : '-',
    actions: {
      id: item['id'],
      status: item['status'],
      schedule_type: normalize(item['schedule_type']),
      // keep this for forward-compat (if backend later switches to `type`)
      type: ['now', 'schedule', 'future'].includes(normalize(item['type']))
        ? normalize(item['type'])
        : normalize(item['schedule_type']),
    },
  }))
}
